/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { decorators } from '@orange-marmalade/paginate-this'
import select from './selectors'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function filterData<T extends React.ComponentType<any>>(Component: T) {
    return decorators.decorate(Component, props => select(props.paginator).filterData())
}
